export const DISTRIBUTOR_FEATURE_UPDATE = 'DISTRIBUTOR_FEATURE_UPDATE'

export const DISTRIBUTOR_FEATURES_SET = 'DISTRIBUTOR_FEATURES_SET'
export const DISTRIBUTOR_FEATURES_UPDATE = 'DISTRIBUTOR_FEATURES_UPDATE'
export const DISTRIBUTOR_FEATURES_FETCHING = 'DISTRIBUTOR_FEATURES_FETCHING'
export const DISTRIBUTOR_FEATURES_UPDATING = 'DISTRIBUTOR_FEATURES_UPDATING'
export const DISTRIBUTOR_FEATURES_BINDINGS_FETCHING =
  'DISTRIBUTOR_FEATURES_BINDINGS_FETCHING'
